export const buildStudyGroupFilesPath = (
  studyGroupId: number,
  folderId?: number | null,
): string => {
  if (!folderId) {
    return `/study-group/${studyGroupId}/files`;
  }

  return `/study-group/${studyGroupId}/files/folder/${folderId}`;
};

export const buildStudyGroupPostPath = (
  studyGroupId: number,
  postId: number,
): string => {
  return `/study-group/${studyGroupId}/post/${postId}`;
};

export const buildStudyGroupLinkListPath = (
  studyGroupId: number,
  categoryId?: number | null,
): string => {
  if (!categoryId) {
    return `/study-group/${studyGroupId}/link-list`;
  }

  return `/study-group/${studyGroupId}/link-list/category/${categoryId}`;
};

export const toAbsoluteStudyGroupLink = (path: string): string => {
  return `${window.location.origin}${path}`;
};
